@if (showSpinner) {
  <div fxFill fxLayoutAlign="center center">
    <mat-spinner></mat-spinner>
  </div>
}
@if (!showSpinner) {
  <div class="button-tab"><span>{{ 'educational_list.button_tab' | translate }}</span></div>
  <mat-form-field>
    <mat-label>{{ 'educational_list.select_label' | translate }}</mat-label>
    <mat-icon svgIcon="chevron" matSuffix></mat-icon>
    <mat-select data-e2e="select_first_level" [(ngModel)]="selectedLevel"
      (selectionChange)="onEducationalLevelChanged($event.value)">
      @for (level of levelsDataEntity; track level) {
        <mat-option [attr.data-e2e]="level.id" [value]="level"
        >{{level.get('label')}}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  @for (concept of levelConcepts; track concept) {
    <app-concept-card [attr.data-e2e]="concept.id" [data]="concept" [hasAssignedLessons]="userHasAssignmentPending(concept.id)"
      [selectedLevelId]="+selectedLevel?.id" [userProgress]="getConceptProgress(concept.id.toString())"
    (idConcept)="storeIddConceptSelected($event)"></app-concept-card>
  }
  @if (showPlaceholder) {
    <img class="placeholder" src="assets/{{ brand }}/images/backgrounds/placeholder.svg" alt="">
  }
}
